import React from 'react';
import { Locale } from '@rbx/intl';
import { NavigationTypeRaw } from '@modules/utilities/pageBuild/types/NavigationRaw';
import { LinkToAssistant } from '@modules/assistant/components/LinkToAssistant';
import { OpenInNewIcon } from '@rbx/ui';
import { trackSearchAskAssistantClicked } from '@modules/search/searchEvents';
import { ESearchInteraction } from '@modules/eventStream/enum/DocsSiteSearch';
import { SearchListItem } from './SearchListItem';
import { TSearchResult } from './types/SearchResult';

interface AskAssistantProps {
  prompt: string;
  label: string;
  locale: Locale;
  searchQuery: string;
  searchSessionId: string;
  searchResults: TSearchResult[];
}

const AskAssistantListItem: React.FC<AskAssistantProps> = ({
  prompt,
  label,
  locale,
  searchQuery,
  searchSessionId,
  searchResults,
}) => {
  const onActivate = () => {
    trackSearchAskAssistantClicked({
      askAssistantLabel: prompt,
      interaction: ESearchInteraction.Click,
      locale,
      query: searchQuery,
      searchSessionId,
      searchResults,
    });
  };

  return (
    <LinkToAssistant
      prompt={prompt}
      onActivate={onActivate}
      aria-label={label}
      style={{ textDecoration: 'none', color: 'inherit' }}
      tabIndex={-1}>
      <SearchListItem
        item={{
          id: 'assistant',
          type: NavigationTypeRaw.Assistant,
          title: prompt,
        }}
        endAdornment={{
          Icon: OpenInNewIcon,
        }}
        locale={locale}
      />
    </LinkToAssistant>
  );
};

export default React.memo(AskAssistantListItem);
